import { Stack, Typography } from '@mui/material';
import { IllustrationComingSoon } from './illustrations/IllustrationComingSoon';

export const ComingSoon = () => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{ height: '100%' }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        spacing={3}
        sx={{ width: '100%' }}
      >
        <IllustrationComingSoon />
        <Stack spacing={1}>
          <Typography
            variant="h3"
            sx={{ fontWeight: 900, textAlign: 'center' }}
          >
            COMING SOON
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontWeight: 400, width: '410px', textAlign: 'center' }}
          >
            {`We are preparing to serve you better.`}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
